



import { nsTerminal } from '@/app/i18n/namespaces';
import Entity from '@/common-utils/components/renders/entity/Entity';
import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import { useEffect } from 'react';

const useCheckConnectionPoints = (getConnectionPointsResponse, setBodyContent, entityRootKey) => {

    const { data, isLoading, error } = getConnectionPointsResponse;

    useEffect(() => {
        if (isLoading) {
            setBodyContent(<Spinner className='top-4' />);
        } else if (error) {
            setBodyContent(<Entity entity={`connections_points.error.${error}`} />);
        } else if (data && data.connectionPoints && data.connectionPoints.length > 0) {
            setBodyContent(<Entity entity={`${entityRootKey}.text`} namespace={nsTerminal} />);
        } else {
            setBodyContent(<Entity entity={`${entityRootKey}.no_connection_points`} namespace={nsTerminal} />);
        }
    }, [data, isLoading, error]);
};

export default useCheckConnectionPoints;
